import { render, staticRenderFns } from "./ItemChip.vue?vue&type=template&id=d01dd04a&scoped=true"
import script from "./ItemChip.vue?vue&type=script&lang=js"
export * from "./ItemChip.vue?vue&type=script&lang=js"
import style0 from "./ItemChip.vue?vue&type=style&index=0&id=d01dd04a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01dd04a",
  null
  
)

export default component.exports